import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, OnChanges, ViewChild} from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, FormControl, NgForm } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {DemoService} from '../../../demo.service';
import {Routes, RouterModule, Router} from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// Notifications
import { HotToastService } from '@ngneat/hot-toast';
import { JobTypeDocument } from '../../../shared/models/jobTypeDocument.model';


import { BillingTask } from '../../../shared/models/billingTask.model';



import { MysqlService } from './../../../services/mysql.service';

import { DatePipe } from '@angular/common';

import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, Observable, Subject} from 'rxjs';

import { FileUploaderService } from './../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { AppRouteABillingItem } from 'src/app/shared/models/appRouteBillingItem.model';

@Component({
  selector: 'app-app-route-billing-item-update',
  templateUrl: './app-route-billing-item-update.component.html',
  styleUrls: ['./app-route-billing-item-update.component.scss']
})
export class AppRouteBillingItemUpdateComponent implements OnInit {



       // setup as observable?
       @Input() item_id?; // impliments on changes.
       @Input() item_data?; // if data.model is sent : Observable<any[]>;
       @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
       @Input() item_user_level_id? = '5'; // default to agent just in case
       @Input() item_brand_type_id? = '';
       @Input() show_buttons? = 'no'; // yes | no
       @Input() widget_title? = '';
       @Input() widget_size? = 'side'; // side | abstract | full
       @Input() app_route_billing_item_id?; //

       

  model: AppRouteABillingItem;
  job_types: any;
  job_type_locations: any;
  count2: any;
  get_latest_court_id: any;
  job_type_courts: any;
  sent_job_type_location_id: any;
  get_latest_document_id: any;
  job_type_affidavit_types: any;
  sent_job_type_document_type_id: any;
  get_latest_type_id: any;

  @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
  myob_account_codes: any;
  myob_tax_codes: any;
  brand_types: any;

 billing_task_id: number;
  billing_task: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  app_route_billing_item: any;
  set_app_route_billing_item_id: any;

  // run this from parent component
@Output('doCalculations') doCalculations: EventEmitter<any> = new EventEmitter();
text: any;

   // access the template form
   @ViewChild('traceForm') traceForm: NgForm;

  constructor(
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router,
     public HttpClient:HttpClient,
     private fileUploader: FileUploaderService,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
     public datepipe: DatePipe,
     public gfunc: GlobalFunctionsService
  ) {



 // Set and Access login Session Variables
 this.gfunc.setLoginSessionVars(); // set in a global function file
 this.sessionUserId = this.gfunc.currentUserVAR.user_id;
 this.sessionUsername = this.gfunc.currentUserVAR.username;
 this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

      // need to add this as routes does not work globally
      this.all_router_details = this.router.url;
      this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

   }




     // check for changes. to load data.
     ngOnChanges(changes) {


      // this.model = new AppRouteABillingItem();
      //   this.getAppRouteBillingItem(this.app_route_billing_item_id);
      //   this.getMyobAccountCodes();
      //   this.getMyobTaxCodes();
      //   this.getJobTypes();
      //   this.getBrandTypes();


      if (changes.app_route_billing_item_id) {
        this.set_app_route_billing_item_id = changes.app_route_billing_item_id.currentValue;
        this.model = new AppRouteABillingItem();
        this.getAppRouteBillingItem(this.app_route_billing_item_id);
        this.getMyobAccountCodes();
        this.getMyobTaxCodes();
        this.getJobTypes();
        this.getBrandTypes();

      }

      
      if (changes.item_id) {
        // deal with asynchronous Observable result
    // this.billing_task_id = changes.item_id.currentValue;
    // this.model = new BillingTask();
    // this.getBillingTask(this.billing_task_id);
    // this.getMyobAccountCodes();
    // this.getMyobTaxCodes();
    // this.getJobTypes();
    // this.getBrandTypes();


        // this.getJob(this.job_id);
      }
    }
  




  ngOnInit() {
    //     this.model = new BillingTask();
    // this.getBillingTask(this.billing_task_id);
    // this.getMyobAccountCodes();
    // this.getMyobTaxCodes();
    // this.getJobTypes();
    // this.getBrandTypes();
    


  }



  getBillingTask(billing_task_id) {
    this._demoService.getBillingTask(billing_task_id).subscribe(
       data => { this.billing_task = data;
        let res = data[0];
        // Run the job data queries.
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   getAppRouteBillingItem(app_route_billing_item_id) {
    this._demoService.getAppRouteBillingItem(app_route_billing_item_id).subscribe(
       data => { this.app_route_billing_item = data;
        let res = data[0];
        // Run the job data queries.
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   createJobType(model) {
    // console.log(model);
        this._demoService.createJobType(model).subscribe(
             data => {  this.get_latest_type_id = data; // this is the retuned json upon creation.
     
               this.traceAddNotice ();
     /*
             // tslint:disable-next-line:max-line-length
             this.router.navigateByUrl('/manager/brand-client-manager/' + this.model.client_brand_id, {skipLocationChange: true}).then(() =>
             this.router.navigate(['/manager/brand-client-contact-manager/' + this.model.brand_id + '/' + this.model.client_brand_id]));
     */

             this.closeParentModel.emit();
   // CreateJobTypeComponent.returned.next(false);
               //  return true;
             },
             error => {
               this.toastr.error('Adding Job Type Failed :: Please try again!');
               // console.log(Observable.throw(error));
               // return Observable.throw(error);
             }
        );
        }
 
 
        traceAddNotice () {
         this.toastr.info('Job Type Added');
       };
 


createBillingTask(model) {
  this._demoService.createBillingTask(model).subscribe(
    data => {  //this.get_latest_type_id = data; // this is the retuned json upon creation.
      this.closeParentModel.emit();
    },
    error => {
     return console.log(error);
    });
};



updateBillingTask(model) {
  this._demoService.updateBillingTask(model).subscribe(
    data => {  //this.get_latest_type_id = data; // this is the retuned json upon creation.
      this.closeParentModel.emit();
      this.toastr.success('billing task updated');
    },
    error => {
      this.toastr.error('billing task update failed');
      console.log(error.error);
      // return Observable.throw(error);
    });
};


updateAppRouteBillingItem(model) {
  this._demoService.updateAppRouteBillingItem(model).subscribe(
    data => {  //this.get_latest_type_id = data; // this is the retuned json upon creation.
      this.closeParentModel.emit();
      this.toastr.success('App Route billing item updated');
    },
    error => {
      this.toastr.error('App Route billing item update failed');
      console.log(error.error);
      // return Observable.throw(error);
    });
};



getMyobAccountCodes() {
  this._demoService.getMyobAccountCodes().subscribe(
     data => { this.myob_account_codes = data;
      let res = data[0];
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 getMyobTaxCodes() {
  this._demoService.getMyobTaxCodes().subscribe(
     data => { this.myob_tax_codes = data;
      let res = data[0];
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 getJobTypes() {
  this._demoService.getJobTypes().subscribe(
     data => { this.job_types = data;
      let res = data[0];
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 getBrandTypes() {
  this._demoService.getBrandBrandTypes().subscribe(
     data => { this.brand_types = data; },
     err => console.error(err),
     // () => console.log('done loading candidate for update')
   );
 }



 onChange(event: any, model) {
console.log("Change detected");

  this.text = event.target.value;
  console.log('New value = ' + event.target.value);
  // update totals if change in qty or fee. 
model.total = model.billing_task_fee * model.qty;





//  if tax update the full dollar amount and quanty
if(model.myob_tax_code_id == '1') {
  model.tax = (model.billing_task_fee / (100 / 10)) * model.qty; // + GST
  // model.tax = model.tax.toFixed(2);
  let rounded_data_tax = Math.round((model.tax + Number.EPSILON) * 100) / 100;
  model.tax = rounded_data_tax;

  model.total = (model.billing_task_fee * model.qty) + model.tax; // + Gst
  // model.total - model.total.toFixed(2); // see if this fixes and rounds down the GST
  let rounded_data_total = Math.round((model.total + Number.EPSILON) * 100) / 100;
  model.total = rounded_data_total;

  // :: Correct Way of working out GST with all prices are NET value.
  // model.tax = (model.billing_task_fee / 11) * model.qty; // net totaal so gst is the total divided by 11
}
if(model.myob_tax_code_id >= '2') {
  model.tax = 0;
}

// this needs to be in a loop and go through all the rows other wise tax code totals do not work correctly. // + GST?????

// seemed to create errors + GST?????
// let  count_of_items = Object.keys(model).length;
//   // need to do a loop of subject_billing items (.length)
//   for(let i=0; i < count_of_items; i++) {
//     let itemData = model[i];

//     if(itemData[i].myob_tax_code_id == '1') {
//       model[i].tax = (itemData[i].billing_task_fee / (100 / 10)) * itemData[i].qty;
//     }
//     if(itemData[i].myob_tax_code_id == '2') {
//       model[i].tax = 0;
//     }
//   } // end for loop of count array




// tax total?

// NEED TO SET THE FORM VALUE DIRECTLY BY SETTING @ouput accessor then setting the new value.
// :: October 2023 - Do calculations when changing the qnatitees and proces - RouteBillingItems - Editing - new Concept
this.traceForm.controls['total'].setValue(model.total); 

};


}